import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const optionTitle: SxStyleFunc<{ selected: boolean }> = ({
  selected,
}) => ({
  color: (p) => (selected ? p.palette.primary[500] : p.palette.common.black),
});

export const dashed: SxStyle = {
  borderStyle: 'solid',
  width: (p) => `calc(100% + ${p.spacing(5)})`,
  marginLeft: (p) => `-${p.spacing(3)}`,
};

export const textField: SxStyle = {
  textTransform: 'none',
  '.MuiInputBase-input': {
    paddingLeft: 2,
    paddingY: 0.5,
    fontSize: (p) => p.typography.body4,
  },
};

export const placehoderTextField: SxStyle = {
  textTransform: 'none',
  '.MuiInputBase-input': {
    paddingLeft: 2,
    paddingY: 0.5,
    color: (p) => p.palette.grey[400],
    fontSize: (p) => p.typography.body4,
  },
};

export const select: SxStyle = {
  '.MuiInputBase-root ': {
    height: (p) => p.spacing(4.5),
  },
};
